import { Action } from 'redux';
import { BasketActionTypes } from '../basket.types';
import { ACTION_CREATOR_NAME } from 'helpers';

export interface SetShowInvalidItemsRemovingWarningAction extends Action<BasketActionTypes.SET_SHOW_INVALID_ITEMS_REMOVING_WARNING> {
    shouldShowInvalidItemsRemovingWarning: boolean;
}

export const setShowInvalidItemsRemovingWarning: (shouldShowInvalidItemsRemovingWarning: boolean) =>
SetShowInvalidItemsRemovingWarningAction = (shouldShowInvalidItemsRemovingWarning: boolean) => ({
    type: BasketActionTypes.SET_SHOW_INVALID_ITEMS_REMOVING_WARNING,
    shouldShowInvalidItemsRemovingWarning
});
setShowInvalidItemsRemovingWarning[ACTION_CREATOR_NAME] = 'setShowInvalidItemsRemovingWarning';

export type SetShowInvalidItemsRemovingWarningFunc = (...args: Parameters<typeof setShowInvalidItemsRemovingWarning>) => void;